import { render, staticRenderFns } from "./ModuleManageSetting.vue?vue&type=template&id=09e227c3&scoped=true"
import script from "./ModuleManageSetting.vue?vue&type=script&lang=js"
export * from "./ModuleManageSetting.vue?vue&type=script&lang=js"
import style0 from "./ModuleManageSetting.vue?vue&type=style&index=0&id=09e227c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e227c3",
  null
  
)

export default component.exports